import {registerTileSchema} from '#core/application/schema-registry.js';

import PRICE_BOOST_LABEL from './price-boost-label.palette-schema.yaml';

registerTileSchema(PRICE_BOOST_LABEL);

export const PRICE_BOOST_ICON_SRC = 'promotion-priceenhancement';

export function generatePriceBoostLabel(TILE) {
    return {
        icon: {
            src: PRICE_BOOST_ICON_SRC,
            style: {
                fill: TILE.PRICE_BOOST_LABEL_ICON_COLOR,
                minHeight: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
                minWidth: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
                width: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
                height: TILE.PRICE_BOOST_LABEL_ICON_SIZE,
            },
        },
        label: {
            style: {
                padding: '0 4px 0 0',
                ...TILE.PRICE_BOOST_LABEL_TEXT,
            },
        },
    };
}
